import Vue from 'vue';
// Components
import button from '@/components/custom/button';
import loading from '@/components/custom/loading';
import input from '@/components/custom/input';
import textarea from '@/components/custom/textarea';
import VueTheMask from 'vue-the-mask';

export default () => {
    // register globally
    Vue.use(VueTheMask);
    Vue.component('eg-loading', loading);
    Vue.component('eg-button', button);
    Vue.component('eg-input', input);
    Vue.component('eg-textarea', textarea);
};
